import { motion } from "framer-motion";
import { useCountdown } from "@/hooks/useCountdown";

const pad = (n) => String(n).padStart(2, "0");

const Block = ({ value, label, testid }) => (
  <div className="flex flex-col items-center gap-2">
    <div className="relative rounded-2xl border border-red-600/30 bg-[#F4F4F5] px-4 py-3 sm:px-6 sm:py-4 shadow-[0_0_25px_rgba(255,0,0,0.12)]">
      <span data-testid={testid} className="font-timer text-3xl sm:text-5xl font-bold tabular-nums text-red-500">
        {value}
      </span>
      <span className="pointer-events-none absolute inset-x-3 top-1/2 h-px bg-red-500/10" />
    </div>
    <span className="text-[10px] sm:text-xs font-mono uppercase tracking-[0.25em] text-slate-500">{label}</span>
  </div>
);

export default function CountdownBlocks() {
  const { hours, minutes, seconds, ms } = useCountdown();
  return (
    <motion.div
      data-testid="countdown-timer-container"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.9, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="w-full"
    >
      <p className="mb-4 text-center text-xs font-mono font-bold uppercase tracking-[0.3em] text-red-500">
        Global Giveaway Deadline — Same For Everyone
      </p>
      <div className="flex items-start justify-center gap-2 sm:gap-4">
        <Block value={pad(hours)} label="Hours" testid="countdown-hours" />
        <span className="pt-3 font-timer text-2xl sm:text-4xl text-red-600/60 sm:pt-4">:</span>
        <Block value={pad(minutes)} label="Minutes" testid="countdown-minutes" />
        <span className="pt-3 font-timer text-2xl sm:text-4xl text-red-600/60 sm:pt-4">:</span>
        <Block value={pad(seconds)} label="Seconds" testid="countdown-seconds" />
        <span className="hidden pt-3 font-timer text-2xl text-red-600/60 sm:block sm:pt-4">:</span>
        <span className="hidden sm:block"><Block value={pad(ms)} label="Ms" testid="countdown-ms" /></span>
      </div>
      <div className="mx-auto mt-6 max-w-md">
        <div className="mb-2 flex justify-between text-[11px] font-mono uppercase tracking-widest text-slate-500">
          <span>Spots filling fast</span>
          <span className="text-red-500">82% claimed</span>
        </div>
        <div className="h-2 overflow-hidden rounded-full bg-slate-200">
          <motion.div
            className="h-full rounded-full bg-gradient-to-r from-red-500 to-red-700"
            initial={{ width: 0 }}
            animate={{ width: "82%" }}
            transition={{ delay: 1.4, duration: 1.4, ease: "easeOut" }}
          />
        </div>
      </div>
    </motion.div>
  );
}

export const MiniCountdown = () => {
  const { hours, minutes, seconds } = useCountdown();
  return (
    <span data-testid="nav-mini-countdown" className="hidden items-center gap-2 rounded-full border border-red-600/30 bg-[#F4F4F5] px-4 py-1.5 font-timer text-sm font-bold tabular-nums text-red-500 md:flex">
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
      </span>
      {pad(hours)}:{pad(minutes)}:{pad(seconds)}
    </span>
  );
};
